import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Card,
  Button,
  Form,
  Badge,
  Image,
  Col,
  Spinner,
} from "react-bootstrap";
import { useParams, useNavigate, Link, useLocation } from "react-router-dom";
import {
  getReviewAllReply,
  addCommentReview,
  addDisputeCommentReview,
} from "api/ReviewService";
import { highlightTagInText } from "utils/helpers";
import moment from "moment";
import { FaStar } from "react-icons/fa";
import { Icon } from "@iconify/react";
import ReactShowMoreText from "react-show-more-text";
import { useAuth } from "context/UserContext";
import { toast } from "react-toastify";
import IMAGES from "../../constants/images";
import { Sentry } from "react-activity";
import BreadcrumbSection from "components/BreadcrumbSection";
import Editor from "components/Editor";
import CollapsibleText from "components/CollapsibleText";
import CommonModal from "components/CommonModal";
import TextInput from "components/TextInput";
import Loader from "components/Loader";
const ReviewComment = () => {
  const [editorLoaded, setEditorLoaded] = useState(false);

  useEffect(() => {
    setEditorLoaded(true);
  }, []);
  const { slug } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [commentLoader, setCommentLoader] = useState(false);
  const navigate = useNavigate();
  const [selectedReason, setSelectedReason] = useState("");
  const [newReply, setNewReply] = useState("");
  const location = useLocation();
  const productName = location.state?.productName;
  const productUrl = location.state?.url;
  const { isLoggedIn, user } = useAuth();
  const userId = user ? user._id : "";
  const [sendDisputeLoader, setSendDisputeLoader] = useState(false);
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [limit] = useState(5);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState("");
  const [review, setReview] = useState({});
  const [newComment, setNewComment] = useState("");

  const allLoaded = comments.length >= total;

  useEffect(() => {
    fetchComments();
  }, [slug, page, limit, search]);

  const fetchComments = async () => {
    setLoading(true);
    const response = await getReviewAllReply({
      reviewId: slug,
      page,
      limit,
      search,
    });

    if (response.success) {
      const newComments = response.body.data;
      if (page === 1) {
        setComments(newComments);
      } else {
        setComments((prev) => [...prev, ...newComments]);
      }
      setReview(response.body.review_data);
      setTotal(response.body.total);
    }
    setPageLoading(false);
    setLoading(false);
  };

  const handleLoadMore = () => {
    if (!allLoaded && !loading) {
      setPage((prev) => prev + 1);
    }
  };

  const handleSendComment = async () => {
    try {
      if (!isLoggedIn) {
        toast.error("Please login to add a comment");
        return;
      }
      if (newComment.trim() === "") {
        return toast.error("Please enter comment");
      }
      setCommentLoader(true);
      const payload = {
        userId: userId,
        reviewId: slug,
        review: newComment.trim(),
      };
      const res = await addCommentReview(payload);
      if (res.success === true && res.code === 200) {
        toast.success("Comment added successfully");
        setNewComment("");
        // Refresh comments
        setPage(1);
        fetchComments();
      } else {
        toast.error(res.message);
      }
      setCommentLoader(false);
    } catch (err) {
      setCommentLoader(false);
      toast.error(err.message || "Something went wrong");
    }
  };

  const handleSendDispute = async () => {
    try {
      if (selectedReason === "") {
        return toast.error("Please a reason");
      }
      if (newReply.trim() === "") {
        return toast.error("Please enter description");
      }
      setSendDisputeLoader(true);
      const payload = {
        userId: user?._id,
        reviewId: review._id,
        productId: review?.productId?._id,
        reason: selectedReason,
        description: newReply.trim(),
      };
      const res = await addDisputeCommentReview(payload);
      if (res.success === true && res.code === 200) {
        toast.success(res.message);
        setShowModal(false);
        setNewReply("");
        setSelectedReason("");
      } else {
        toast.error(res.message);
      }
      setSendDisputeLoader(false);
    } catch (err) {
      setSendDisputeLoader(false);
      toast.error(err.message || "Something went wrong");
    }
  };

  function htmlToFormattedText(html) {
    if (!html) return "";

    // Replace <br>, <br/> with newlines
    let text = html.replace(/<br\s*\/?>/gi, "\n");

    // Replace paragraph tags with newlines
    text = text.replace(/<\/p>/gi, "\n\n");

    // Remove all other tags
    text = text.replace(/<[^>]+>/g, "");

    // Optional: trim spaces on each line
    text = text
      .split("\n")
      .map((line) => line.trim())
      .join("\n")
      .trim();

    return text;
  }

  const handleCloseModal = () => {
    setShowModal(false);
    setNewReply("");
  };
  console.log("review", review);
  return (
    <React.Fragment>
      <BreadcrumbSection
        breadcrumbs={[
          ...(productName ? [{ title: productName, link: productUrl }] : []),

          { title: "Review comment" }, // Active breadcrumb (no link)
        ]}
      />
      {pageLoading ? (
        <div className="loaderdiv">
          {/* <Sentry color="#e91515" size={40} speed={1} animating={true} /> */}
          <Loader />
        </div>
      ) : (
        <React.Fragment>
          <section className="review-comment-section py-5 bg-light">
            <Container>
              <Row>
                {/* <div className="mb-3 d-flex justify-content-end ">
              <Button
                variant="outline-info"
                as={Link}
                to={`/product-details/${review.productId?.slug || ''}`}
                className="border-radius-100 px-5 d-flex flex-column justify-content-center align-items-center"
              >
                Back
              </Button>
            </div> */}
                <Col>
                  <div className="review_Section mb-2">
                    <div className="commentCard ">
                      <Card>
                        <Card.Body>
                          <div className="d-flex justify-content-between align-items-start mb-2 mb_Flex">
                            <div className="d-flex justify-content-between align-items-start mb-2 mb_Flex">
                              <div>
                                <Card.Title>
                                  <h5 style={{ fontSize: "1em" ,wordBreak:"break-all"}}>
                                    "{review?.title}"
                                  </h5>
                                </Card.Title>
                                <div className="d-flex align-items-center mb-2">
                                  {Number.isFinite(
                                    Number(review?.overallRating)
                                  ) &&
                                    [
                                      ...Array(
                                        Math.floor(
                                          Number(review?.overallRating)
                                        )
                                      ),
                                    ].map((_, i) => (
                                      <FaStar
                                        key={i}
                                        color="gold"
                                        className="me-1"
                                      />
                                    ))}
                                  <span className="ms-2 text-muted">
                                    {moment(review?.createdAt).format("LL")}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {user?.role == "vendor" && (
                              <div className="d-flex gap-4 helpFull">
                                {review?.productId?.userId === user?._id && (
                                  <div
                                    style={{ cursor: "pointer" }}
                                    onClick={() => setShowModal(true)}
                                    className="text-decoration-none blueColor d-flex align-items-center "
                                  >
                                    <Icon
                                      icon="bx:comment-detail"
                                      fontSize={20}
                                      className="me-2"
                                    />{" "}
                                    Dispute
                                  </div>
                                )}
                              </div>
                            )}
                          </div>

                          <Card.Text as="div">
                            <CollapsibleText lines={5}>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: review?.review,
                                }}
                                style={{
                                  whiteSpace: "pre-wrap",
                                  lineHeight: "1.6",
                                  marginBottom: "1rem",
                                  wordBreak: "break-all",
                                }}
                              />
                            </CollapsibleText>
                          </Card.Text>
                        </Card.Body>
                      </Card>

                      <div className="cardFooter">
                        <div className="userBox">
                          <div
                            className="userImage cursor-pointer"
                            onClick={() => {
                              // if (!userId) {
                              //   toast.error("Please login first");
                              //   return;
                              // }
                              navigate(
                                review?.userId?._id === userId
                                  ? `/my-profile`
                                  : `/public-profile/${review?.userId?._id}`
                              );
                            }}
                          >
                            <Image
                              src={
                                review?.userId?.profileUrl || IMAGES.User2_Img
                              }
                              className="userPos"
                              alt=""
                            />
                            {review?.userId?.isProfileVerify !== "pending" && (
                              <Image
                                src={IMAGES.Verified}
                                className="iconPos"
                                alt=""
                              />
                            )}
                          </div>
                          <div
                            className="flex-grow-1 cursor-pointer"
                            onClick={() => {
                              // if (!userId) {
                              //   toast.error("Please login first");
                              //   return;
                              // }
                              navigate(
                                review?.userId?._id === userId
                                  ? `/my-profile`
                                  : `/public-profile/${review?.userId?._id}`
                              );
                            }}
                          >
                            <strong>
                              {review?.userId?.displayName
                                ? review?.userId?.displayName
                                : `${review?.userId?.firstName} ${
                                    review?.userId?.lastName || ""
                                  }`}
                            </strong>
                            <p className="mb-0" style={{ fontSize: "0.9em" }}>
                              {[
                                review?.userId?.title || "",
                                review?.userId?.industry?.title || "",
                              ]
                                .filter(Boolean)
                                .join(", ") +
                                (review?.userId?.companySize !== undefined &&
                                review?.userId?.companySize !== null &&
                                review?.userId?.companySize !== ""
                                  ? ` (${review?.userId?.companySize?.title} emp.)`
                                  : "")}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              {/* Comment Form */}
              {isLoggedIn && (
                <Row className="mt-4 mb-3">
                  <Col>
                    <Card>
                      <Card.Body>
                        <Form.Group>
                          <Form.Label className="fs-4 fw-bold mb-1">
                            Comment on Review
                          </Form.Label>
                          <p className="fs-6 mb-3 opacity-25">
                            {" "}
                            Share your thoughts or ask questions about this
                            review to join the conversation and provide
                            additional insights.
                          </p>
                          <Form.Control
                            as="textarea"
                            rows={6}
                            value={newComment}
                            maxLength={4000}
                            onChange={(e) => setNewComment(e.target.value)}
                            placeholder="Write your comment here..."
                          />
                          {/* <Editor
                            value={newComment}
                            placeholder={"Write your comment here..."}
                            name="description"
                            onChange={(data) => {
                              // setComment(e.target.value)
                              setNewComment(data);
                            }}
                          /> */}
                        </Form.Group>
                        <Button
                          variant="primary"
                          className="mt-2"
                          onClick={handleSendComment}
                          disabled={commentLoader}
                          style={{ minWidth: "180px" }}
                        >
                          {commentLoader ? (
                            <Spinner animation="border" size="sm" />
                          ) : (
                            "Post Comment"
                          )}
                        </Button>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              )}
              <p className="mt-4">Replies {total > 0 && `(${total})`}</p>
              {/* Comment List */}
              {!loading && comments?.length === 0 && (
                <Col xs={12}>
                  <div className="text-center py-5">
                    <Image
                      src={IMAGES.emptyState}
                      alt=""
                      height="100px"
                      width="100px"
                      className="mb-4"
                      // className="imgUser"
                    />
                    <p className="text-center text-muted">No replies found.</p>
                  </div>
                </Col>
              )}
              {comments?.map((item, index) => (
                <Card key={index} className="mb-3 shadow-sm">
                  <Card.Body className="d-flex gap-3">
                    <div
                      className="userImage cursor-pointer"
                      onClick={() => {
                        // if (!userId) {
                        //   toast.error("Please login first");
                        //   return;
                        // }
                        navigate(
                          item?.userId?._id === userId
                            ? `/my-profile`
                            : `/public-profile/${item?.userId?._id}`
                        );
                      }}
                    >
                      <Image
                        src={item?.userId?.profileUrl || IMAGES.User2_Img}
                        roundedCircle
                        width={50}
                        height={50}
                        alt="User Avatar"
                      />
                    </div>
                    <div className="w-100">
                      <div className="headerF cursor-pointer">
                        <h6
                          className="mb-1 "
                          onClick={() => {
                          
                            navigate(
                              item?.userId?._id === userId
                                ? `/my-profile`
                                : `/public-profile/${item?.userId?._id}`
                            );
                          }}
                        >
                          {item?.userId?.displayName
                            ? item?.userId?.displayName
                            : `${item?.userId?.firstName} ${item?.userId?.lastName}`}
                        </h6>
                        <small className="text-muted">
                          {moment(item.createdAt).format("MMMM D, YYYY")}
                        </small>
                      </div>

                      <Card.Text className="para">
                        <CollapsibleText lines={5}>
                          <div
                            dangerouslySetInnerHTML={{ __html: item.review }}
                            style={{
                              whiteSpace: "pre-wrap",
                              lineHeight: "1.6",
                              marginBottom: "1rem",
                              wordBreak: "break-all",
                            }}
                          />
                        </CollapsibleText>
                      </Card.Text>
                    </div>
                  </Card.Body>
                </Card>
              ))}

              {/* Load More Button */}
              <div className="text-center d-flex justify-content-center mt-4">
                {!allLoaded ? (
                  <Button
                    className="added_width1"
                    variant="outline-primary"
                    onClick={handleLoadMore}
                    disabled={loading}
                    style={{
                      width: "351px",
                      borderRadius: "50px",
                      borderColor: "#0071E3",
                      color: "#0071E3",
                    }}
                  >
                    {loading ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      "More Reviews"
                    )}
                  </Button>
                ) : (
                  page > 1 && (
                    <p className="text-muted" style={{ display: "none" }}>
                      No more comments to load
                    </p>
                  )
                )}
              </div>
            </Container>
          </section>
        </React.Fragment>
      )}

      <CommonModal
        title={"Dispute a Review"}
        para={"Describe your issue, and we’ll review it to find a solution."}
        body={
          <div className="mt-4">
            <Form.Group className="mb-3">
              <Form.Label className="d-block text-start">Reason</Form.Label>
              <Form.Select
                placeholder="Select Reason"
                value={selectedReason}
                onChange={(e) => setSelectedReason(e.target.value)}
              >
                <option>Select Reason</option>
                <option>Inappropriate Content</option>
                <option>Spam or Misleading</option>
                <option>Factually Incorrect</option>
                <option>Competitor Review</option>
                <option>Violates Terms of Service</option>
                <option>Other</option>
              </Form.Select>
            </Form.Group>
            <TextInput
              labelText={"Description"}
              type="text"
              textarea="textarea"
              value={newReply}
              onChange={(e) => setNewReply(e.target.value)}
              rows={6}
              maxLength={1000}
              placeholder={"Explain dispute in detail..."}
              // errorMessage="Description is required"
            />

            <Button
              disabled={sendDisputeLoader}
              onClick={handleSendDispute}
              variant="info"
              className="w-100 mt-4 border-radius-100"
            >
              {sendDisputeLoader ? (
                <Spinner animation="border" size="sm" />
              ) : (
                "Submit"
              )}
            </Button>
          </div>
        }
        show={showModal}
        onClose={handleCloseModal}
      />
    </React.Fragment>
  );
};

export default ReviewComment;
